import * as React from 'react';
import { FormGroup } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { useMemo } from 'react';

import { Checkbox, CheckboxProps } from 'theSource/components/Checkbox';
import { FormControlLabelStyled } from './CheckboxFieldStyled';
import { FormField } from '../FormField';

interface CheckboxFieldProps
  extends Omit<CheckboxProps, 'checked' | 'onChange'> {
  label: string;
  name: string;
  required?: boolean;
}

export const CheckboxField = ({
  disabled,
  required,
  label,
  name,
  id,
  ...props
}: CheckboxFieldProps) => {
  const [{ checked, ...field }, { error, touched }] = useField({
    name,
    type: 'checkbox',
  });
  const { isSubmitting } = useFormikContext();

  const invalid = useMemo(() => touched && Boolean(error), [error, touched]);

  return (
    <FormField
      error={invalid}
      required={required}
      fullWidth
      inputId={id}
      helperText={invalid ? error : ''}
    >
      <FormGroup data-testid="checkbox-field">
        <FormControlLabelStyled
          control={
            <Checkbox
              checked={checked ?? false}
              disabled={disabled || isSubmitting}
              id={id}
              {...field}
              {...props}
            />
          }
          label={label}
        />
      </FormGroup>
    </FormField>
  );
};
